import BankAccount from "@/components/BankAccount";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect, useState } from "react";
import type { BankAccount as BankAccountType } from "@/model/account";
import type { User } from "@/model/user";

interface Props {
  corporateUsers: User[] | undefined;
  selectedCorporateUserId: string;
  accounts: BankAccountType[] | undefined;
  selectAccount: (account: BankAccountType) => void;
  setSelectedCorporateUserId: (corporateUserId: string) => void;
  isLoading: boolean;
}

export default function CorporateUsers({
  accounts,
  selectedCorporateUserId,
  corporateUsers,
  selectAccount,
  setSelectedCorporateUserId,
  isLoading,
}: Props) {
  const [corporateAccounts, setCorporateAccounts] = useState<BankAccountType[]>(
    [],
  );

  useEffect(() => {
    if (accounts) {
      const filteredAccounts = accounts?.filter(
        (account) => account.userId === selectedCorporateUserId,
      );
      setCorporateAccounts(filteredAccounts);
    }
  }, [selectedCorporateUserId, accounts]);

  const hasNoCompanies =
    !corporateUsers || corporateUsers.length === 0;
  const hasSingleCompany =
    corporateUsers && corporateUsers.length === 1;
  const singleCompany = hasSingleCompany ? corporateUsers[0] : null;

  return (
    <div className="flex flex-col gap-2">
      {!hasNoCompanies && (
        <>
          {hasSingleCompany && singleCompany ? (
            <div className="rounded-md border border-border bg-muted/30 px-3 py-2">
              <span className="text-sm font-medium">
                {singleCompany.corporateName ||
                  singleCompany.debtorCorpExternalId}
              </span>
            </div>
          ) : (
            <Select
              value={selectedCorporateUserId}
              onValueChange={(userId) => setSelectedCorporateUserId(userId)}
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder="Velja" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Fyrirtækjanotendur</SelectLabel>
                  {corporateUsers?.map((corporateUser) => (
                    <SelectItem
                      key={corporateUser.id}
                      value={corporateUser.id}
                    >
                      <div className="flex gap-2">
                        <span>
                          {corporateUser.corporateName ||
                            corporateUser.debtorCorpExternalId}
                        </span>
                      </div>
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          )}
        </>
      )}
      {corporateAccounts?.map((account, index) => (
        <BankAccount
          key={account.id}
          bankAccount={account}
          selectAccount={(account) => selectAccount(account)}
          isLoading={isLoading}
          className={
            index === 0
              ? "shadow-[0_0_22px_rgba(140,238,123,0.55)] ring-1 ring-[#8CEE7B]/50"
              : undefined
          }
        />
      ))}
    </div>
  );
}
